import './head.scss'
import { useLocation, useNavigate }from "react-router-dom"; 
import { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { AppContext, channel } from '@utils/AppContext';
import { Menu, Divider, message, Popover, Button, Modal  } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import LoginModal from '../loginModal';
import LoggedHead from './loggedHead/loggedHead';
import LoginHead from './loginHead/loginHead';
import eventBus from '@utils/eventBus';
import Utils from '@utils/utils'
import styles from './head.module.scss'
import { HOME_PAGE_TYPE } from "@utils/CONST"
import PSAIModal from '@PSAIComponents/PSAIModal';
import dayjs from 'dayjs';
import useResizeObserver from "@utils/useResizeObserver";

const Head = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const { globalHomePageType, globalActivity, updateGlobalHomePageType } = useContext(AppContext);
    const [loginOpen, setLoginOpen] = useState(false)
    const [mobile, setMobile] = useState()
    const [iconRotate , setIconRotate] = useState(0)
    const loginCallback = useRef()

    useEffect(() => {
        const handleLoginMessage = ({mobile, callback}={}) => {
            if (localStorage.getItem('token')) {
                message.info('您已登录')
            } else {
                setMobile(mobile)
                setLoginOpen(true)
            }
            if (callback) loginCallback.current = callback
        }

        eventBus.on('login', handleLoginMessage);

        return () => {
            eventBus.off('login', handleLoginMessage);
        }
    }, [])

    const loginClick = () => {
        setLoginOpen(true)
    }

    const type = useMemo(() => {
        if (globalHomePageType == HOME_PAGE_TYPE.MERCHANDISE) return 'AI商品图'
        else if (globalHomePageType == HOME_PAGE_TYPE.CLOTHING) return '服装模特图'
        else if (globalHomePageType == HOME_PAGE_TYPE.IMAGE_SERVICE) return "AI商拍服务"
    }, [globalHomePageType])

    const logoShowType = useMemo(() => { // 左上角logo显示品类
        return false
        // return ![
        //     '/',
        //     '/membership',
        //     '/connect_us',
        //     '/home/homemain/personalCenter'
        // ].includes(location.pathname)
    }, [location.pathname])

    useEffect(() => {
        if (!loginOpen) setMobile('')
    }, [loginOpen])

    const goToAIEdit = (menuKey) => {
        updateGlobalHomePageType(HOME_PAGE_TYPE.CLOTHING)
        navigate("/home/homemain/aiEdit", { state: { menuKey: menuKey } })
    }

    const menuChange = (e) => {
        const lastKey = e.keyPath[e.keyPath.length - 1]
        if (lastKey == HOME_PAGE_TYPE.CLOTHING) {
            Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', {from: 'homeMenu'})
            Utils.clearClothesTaskCache()
            navigate(e.key)
        } else if (lastKey == HOME_PAGE_TYPE.MERCHANDISE) {
            Utils.useroplog(HOME_PAGE_TYPE.MERCHANDISE, 'function', 'navigation', {from: 'homeMenu'})
            Utils.clearMerchandiseTaskCache()
            navigate(e.key)
        } else if (e.key == "/home/image_extraction") {
            navigate(e.key)
        } else if (e.key == "/home/imageResize") {
            navigate(e.key)
        } else if (e.key == "magicErase") {
            goToAIEdit("magicErase")
        } else if (e.key == "filllight") {
            goToAIEdit("filllight")
        } else if (e.key == "beautify") {
            goToAIEdit("beautify")
        } else if (e.key == "/service") {
            navigate(e.key)
        }
    }

    const selectedKeys = useMemo(() => {
        if (location.pathname == "/home/homemain/aiEdit") return ["AITOOL"]
        else return [location.pathname]
    }, [location])

    const items = [{
        key: HOME_PAGE_TYPE.CLOTHING,
        label: "服饰版",
        popupClassName: styles.MenuPopup,
        popupOffset: [-90, 0],
        children: [{
            key: "/home/homemain/clothes",
            label: <p className={`${styles.MenuLable} ${styles.ChangeCloth}`}>AI试衣</p>
        }, {
            key: "/home/homemain/model",
            label: <p className={`${styles.MenuLable} ${styles.ChangeBg}`}>AI模特</p>
        }, {
            key: "/home/homemain/shoesTryon",
            label: <p className={`${styles.MenuLable} ${styles.ChangeShoes}`}>鞋子上脚</p>
        }, {
            key: "/home/homemain/model_video",
            label: <p className={`${styles.MenuLable} ${styles.ChangetoV}`}>模特视频</p>
        }]
    }, {
        key: HOME_PAGE_TYPE.MERCHANDISE,
        label: "商品版",
        popupClassName: styles.MenuPopup,
        popupOffset: [-90, 0],
        children: [{
            key: "/home/homemain/commodity",
            label: <p className={`${styles.MenuLable} ${styles.ChangeGoods}`}>商品图</p>
        }, {
            key: "/home/homemain/commodityRecolor",
            label: <p className={`${styles.MenuLable} ${styles.ChangeColor}`}>商品换色</p>
        }]
    }, {
        key: "AITOOL",
        label: <p className={styles.FreeLimitTag}>AI编辑<span>限免</span></p>,
        popupClassName: styles.MenuPopup,
        popupOffset: [-90, 0],
        children: [{
            key: "/home/image_extraction",
            label: <p className={`${styles.MenuLable} ${styles.Keying}`}>智能抠图</p>
        }, {
            key: "/home/imageResize",
            label: (
                <div className={`${styles.MenuLable} ${styles.Resize}`}>
                    <p className={styles.FreeLimitTag}>高清改尺寸<span>限免</span></p>
                </div>
            )
        }, {
            key: "magicErase",
            label: <p className={`${styles.MenuLable} ${styles.Eraser}`}>魔法擦除</p>
        }, {
            key: "filllight",
            label: <p className={`${styles.MenuLable} ${styles.Relight}`}>智能补光</p>
        }, {
            key: "beautify",
            label: <p className={`${styles.MenuLable} ${styles.Beauty}`}>智能美化</p>
        }]
    }, 
    
    // {
    //     key: "/service",
    //     label: <p className={styles.NewTag}>AI服务助手<span>NEW</span></p>,
    // }, 
    
    {
        key: "/connect_us",
        label: <a href="/connect_us">关于我们</a>,
    }]


    const onOpenChange = (openKeys) => {
        if (openKeys.length > 0) {
            setIconRotate(180)
        } else {
            setIconRotate(0)
        }
    }

    const goBack = () => {
        navigate('/')
    }

    // 活动状态 0-未开始 1-进行中 2-已结束
    const ACTIVITY_240711_STATUS = useMemo(() => {
        if (!globalActivity) return 0
        const activity = globalActivity.ACTIVITY_240711
        // const now = dayjs('2024-07-14')
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        const end = dayjs(activity.endAt)
        return now.isBefore(start) ? 0 : now.isAfter(end) ? 2 : 1 
    })

    const loginCloseFunc = (logged, isRegister) => {
        setLoginOpen(false)
        if (logged) {
            Utils.clearAllTaskCache()
            if (isRegister) { // 首次登录
                if (ACTIVITY_240711_STATUS == 1) eventBus.emit('cashbackActivity') // 返现活动
                else eventBus.emit('inviteUser')
                eventBus.emit('rewardMessage', '首次登录赠送豆数', 500)
            } else {
                message.success('登录成功', 5)
            }
        }
        if (loginCallback.current) {
            loginCallback.current(!!logged)
            loginCallback.current = null
        } else {
            const urlParams = new URLSearchParams(location.search)
            const redirect = urlParams.get('redirect')
            if (redirect) navigate(redirect)
        }
    }

    const isImageExtraction = useMemo(() => {
        return location.pathname == '/home/image_extraction'
    }, [location])

    const isImageResize = useMemo(() => {
        return location.pathname == '/home/imageResize'
    }, [location])

    const [leftWidth, setLeftWidth] = useState(0)
    const [rightWidth, setRightWidth] = useState(0)
    const [centerWidth, setCenterWidth] = useState(0)
    const leftRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            for (let boxSize of entry.borderBoxSize) {
                setLeftWidth(boxSize.inlineSize)
            }
        }
    })
    const rightRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            for (let boxSize of entry.borderBoxSize) {
                setRightWidth(boxSize.inlineSize)
            }
        }
    })
    const centerRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            setCenterWidth(entry.contentRect.width)
        }
    })
    const offsetMagin = useMemo(() => {
        return Math.max(rightWidth - leftWidth, 0)
    }, [leftWidth, rightWidth])
    const totalWidth = useMemo(() => {
        return leftWidth + rightWidth + centerWidth + offsetMagin
    }, [leftWidth, rightWidth, centerWidth, offsetMagin])
    const offsetMaginDisabled = useMemo(() => {
        return totalWidth > window.innerWidth
    }, [totalWidth])

    return (
        <>
            <div className='Head LoginHead' style={{ backgroundColor: `${props.noBackground ? 'transparent' : '#FFFFFF'}` }}>
                <div className="head_left" ref={leftRef} style={{marginInlineEnd:offsetMaginDisabled ? 0 : offsetMagin}}>
                {
                    isImageExtraction || isImageResize ?
                    <div style={{display: 'flex', alignItems: 'center', fontSize: '16px', fontWeight: 700, whiteSpace: 'nowrap'}}>
                        <i className='logo2' onClick={goBack}></i>
                        <span style={{position: "relative", top: 2}}>{isImageExtraction ? '智能抠图': '高清改尺寸'}</span>
                    </div> :
                    <>
                    {
                        logoShowType ?
                        <>
                        {type == '服装模特图' && <i className='logo2 cloth_logo' onClick={goBack}></i>}
                        {type == 'AI商品图' && <i className='logo2 mc_logo' onClick={goBack}></i>}
                        {type == 'AI商拍服务' && <i className='logo2' onClick={goBack}></i>}
                        </> :
                        <i className='logo2' onClick={goBack}></i>
                    }
                    </>
                }
                </div>
                <div className="head_center" ref={centerRef}>
                    <Menu
                        className={styles.HeadMenu}
                        key={location.pathname}
                        selectedKeys={selectedKeys}
                        mode="horizontal"
                        items={items}
                        onClick={menuChange}
                        onOpenChange={onOpenChange}
                    />     
                </div>
                <div className="head_right" ref={rightRef}>
                {
                    localStorage.getItem('token') ? 
                        <LoggedHead /> :
                        <LoginHead onLogin={loginClick} />
                }
                </div>
                {
                    localStorage.getItem('channel') == 'taobao'?<p className='tips'>注:通过淘宝服务市场购买的虹豆豆仅能在此使用</p>: null
                }
            </div>
            <PSAIModal
                maxWidth={950}
                open={loginOpen}
                footer={null}
                closable={false}
                onCancel={() => loginCloseFunc(false)}
            >
                <LoginModal open={loginOpen} mobile={mobile} closeFunc={loginCloseFunc} />
            </PSAIModal>
        </>
    );
};

export default Head;